// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'bd3d2aaf-a466-495d-b6be-b4a47b7fcdc5',
      type: 'Container',
      name: 'contentWrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '1a7eab4c-68c7-4dbd-82ac-a59319212b63',
      type: 'Container',
      name: 'spinnerSlot',
      className: '',
      x: 0,
      y: 600,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '70e71c9f-33b3-46e2-9f0d-e4da48833694',
      type: 'Container',
      name: 'offerContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bd3d2aaf-a466-495d-b6be-b4a47b7fcdc5'
    },
    {
      id: 'c647a4e7-3e5e-4a56-a1bd-3e0ff34bac29',
      type: 'Sprite',
      name: 'scrollInput',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -1000,
        y: 0,
        width: 2000,
        height: 3000
      },
      texture: '',
      parent: 'bd3d2aaf-a466-495d-b6be-b4a47b7fcdc5'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class ShopInventoryLayout {
  static raw = raw;
  root!: Container;
  contentWrapper!: Container;
  spinnerSlot!: Container;
  offerContainer!: Container;
  scrollInput!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
